export default "/_nuxt/2aeace8feb64723591631a73a455433c.svg";